/* eslint-disable */

import moment from 'moment';
import React, { useState, useRef, useEffect } from 'react';
import DateRangePicker from './RedesignedDatePicker';

const AlgoDateRangePickerContainer = (props) => {
    const { start_date, end_date } = props.values ?? {};

    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const handleToggle = () => setOpen((prev) => !prev);

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const defaultValues =
        start_date && end_date
            ? {
                  start_date,
                  end_date,
              }
            : null;

    return (
        <div className="dropdown-container" ref={dropdownRef}>
            <button onClick={handleToggle} className="date-picker-global-input">
                <span className="d-flex gap-8 align-items-center">
                    <i className="icon-calendar1" />
                    {start_date ? moment(start_date).format('DD MMM YYYY') : '-'} -{' '}
                    {end_date ? moment(end_date).format('DD MMM YYYY') : '-'}
                </span>
                <i className="icon-fi_chevron-down" />
            </button>

            {open && (
                <div className="dropdown-panel">
                    <div className="calendar-wrapper">
                        <DateRangePicker
                            updateSelect={props.updateSelect}
                            gsc_report={props.gsc_report}
                            onClose={() => setOpen(false)}
                            minDate={props.minDate}
                            maxDate={props.maxDate}
                            header={props.header}
                            defaultValues={defaultValues}
                            options={props.options}
                            hasOptions={props.options?.length > 0}
                            selectRange={props.selectRange}
                            emptyRange={props.emptyRange}
                            isFromGSC={props.isFromGSC}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default AlgoDateRangePickerContainer;
